export default __webpack_public_path__ + "static/bg-api-659a5aab32288c1636b2a54fdd41f592.webp";